 <div
        class="checkout-close absolute flex align-items-center justify-content-center cursor-pointer"
        (click)="dialogRef.close()">
        <i class="ph ph-x"></i>
    </div>

    <p-header class="checkout">
        <div class="flex justify-content-center p-2 border-bottom-1 surface-border">
            <img
                src="assets/images/DFC-logo.webp"
                alt="DFC Logo"
                class="h-4rem p-2 w-auto"
            />
        </div>
    </p-header>

    <div class="flex flex-column">
        <p class="text-center m-0 mb-2 line-height-3 text-lg font-bold text-900">
            Join
            <span *ngIf="!premiumOdometerReady" class="user-count inline-block">{{ userCount | number:'1.0-0' }}</span>
            <span #premiumOdometerElem *ngIf="premiumOdometerReady" class="user-count inline-block"></span>
            travelers saving <br />
            thousands on flights every year.
        </p>

        <div class="mb-2">
            <ul class="list-none p-0 m-0 flex align-items-center justify-content-evenly gap-1 w-full">
                <li
                    *ngFor="let item of modalInfo"
                    class="flex align-items-center text-xs font-medium text-700">
                    <i class="pi pi-check small-check flex align-items-center justify-content-center border-circle mr-1"></i>
                    {{ item }}
                </li>
            </ul>
        </div>

        <div class="px-2 pb-2 flex flex-column gap-1">
            <label for="currency" class="text-sm font-semibold text-600">Select Currency:</label>
            <select
                id="currency"
                class="fco-select w-full"
                [(ngModel)]="pricing.selectedCurrency"
                (change)="updateCurrencyDisplay()">
                <option *ngFor="let currency of pricing.availableCurrencies" [value]="currency">
                    {{ currency }}
                </option>
            </select>
        </div>

        <form class="px-2 pt-1 pb-2 flex flex-column gap-2" [formGroup]="cardDetailsForm">
            <div id="link-authentication-element" #linkauth></div>
            <div id="payment-element" #paymentElement></div>

            <div *ngIf="fundingGuard.warning" class="mt-2 text-sm text-orange-600">
                {{ fundingGuard.warning }}
            </div>

            <div *ngIf="!hideCouponInput" class="flex flex-column align-items-end my-1 w-full gap-2">
                <span
                    *ngIf="!couponState.showCouponInput"
                    class="coupon-toggle text-xs cursor-pointer"
                    (click)="toggleCouponInput()">
                    Have a coupon?
                </span>

                <div *ngIf="couponState.showCouponInput" class="flex align-items-center gap-2 mt-1 w-full">
                    <input
                        type="text"
                        formControlName="coupon"
                        placeholder="Enter promo code"
                        class="coupon-input flex-1"
                    />
                    <button
                        pButton
                        type="button"
                        label="Apply"
                        class="coupon-apply-button"
                        (click)="applyCoupon()">
                    </button>
                </div>
            </div>

            <div *ngIf="couponState.discountApplied" class="coupon-success text-center text-sm">
                <i class="pi pi-check-circle"></i>
                {{ couponState.discountMessage }}
            </div>

            <div class="pb-1">
                <button
                    pButton
                    type="button"
                    (click)="onSubmit()"
                    [disabled]="loading || fundingGuard.isBlocked"
                    class="p-button-primary full-width w-full flex align-items-center justify-content-center">
                    <span *ngIf="!loading" class="font-bold">{{ buttonText }}</span>
                    <span *ngIf="loading" class="flex align-items-center justify-content-center">
                        <i class="pi pi-spinner pi-spin"></i>
                    </span>
                </button>
            </div>
        </form>
    </div>

    <p class="modal-legal absolute m-0 text-center line-height-2 text-xs">
        By continuing you agree to our
        <a href="https://dollarflightclub.com/terms-of-use" target="_blank" rel="noreferrer noopener">Terms</a>,
        <a href="https://dollarflightclub.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        and annual renewal. Cancel your plan anytime. Renewal charges may vary with exchange rates.
    </p>

